import { yupResolver } from '@hookform/resolvers/yup';
import automaticReloadParametersFormMeta from '@Modules/cardManagementSystem/cardholder/containers/formHandler/cardData/accountDetail/prePaidReloadParameters/formMeta/automaticReloadParametersFormMeta';
import initialChargeParametersFormMeta from '@Modules/cardManagementSystem/cardholder/containers/formHandler/cardData/accountDetail/prePaidReloadParameters/formMeta/initialChargeParametersFormMeta';
import limitReloadFormMeta from '@Modules/cardManagementSystem/cardholder/containers/formHandler/cardData/accountDetail/prePaidReloadParameters/formMeta/limitReloadFormMeta';
import { IPrePaidReloadParametersFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/formHandler/cardData/accountDetail/prePaidReloadParameters/formMeta/PrePaidReloadParametersFormMeta';
import CustomFieldSet from '@Modules/core/components/CustomFieldSet';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import CustomInput from '@Modules/core/components/form/CustomInput';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import { getFormFieldsName } from '@Shared/utils/getFormFieldsNames';
import React from 'react';
import { useForm } from 'react-hook-form';

type Props = {
  meta: IPrePaidReloadParametersFormMeta,
} & TFormUIProps;

const PrePaidReloadParametersFormUI: React.FC<Props> = ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CustomFieldSet title={'Paramètres Charge Initial'}>
        <CC.SimpleGrid
          columns={{ base: 1, lg: 2 }}
          gridRowGap={4}
          columnGap={10}
          my={4}
        >
          {displayCustomInputs<IPrePaidReloadParametersFormMeta>(
            meta,
            register,
            errors,
            isLoading,
            [...getFormFieldsName(initialChargeParametersFormMeta)]
          )}
        </CC.SimpleGrid>
      </CustomFieldSet>

      <CustomFieldSet title={'Recharge Limites'}>
        <CC.SimpleGrid
          columns={{ base: 1, lg: 2 }}
          gridRowGap={4}
          columnGap={10}
          my={4}
        >
          {displayCustomInputs<IPrePaidReloadParametersFormMeta>(
            meta,
            register,
            errors,
            isLoading,
            [...getFormFieldsName(limitReloadFormMeta)]
          )}
        </CC.SimpleGrid>
      </CustomFieldSet>

      <CustomFieldSet title={'Paramètres Recharge Automatique'}>
        <CC.SimpleGrid
          columns={{ base: 1, lg: 2 }}
          gridRowGap={4}
          columnGap={10}
          my={4}
        >
          {displayCustomInputs<IPrePaidReloadParametersFormMeta>(
            meta,
            register,
            errors,
            isLoading,
            [...getFormFieldsName(automaticReloadParametersFormMeta)],
            [
              automaticReloadParametersFormMeta.automaticReload.name,
              automaticReloadParametersFormMeta.reload.name,
            ]
          )}
        </CC.SimpleGrid>

        <CustomFormControl
          isLoading={isLoading}
          label={automaticReloadParametersFormMeta.reload.label}
          isInvalid={!!errors[automaticReloadParametersFormMeta.reload.name]} w={"full"} my={4}
        >
          <CustomInput
            hasError={errors[automaticReloadParametersFormMeta.reload.name]}
            register={register(automaticReloadParametersFormMeta.reload.name)}
            meta={automaticReloadParametersFormMeta.reload}
          />
        </CustomFormControl>

        <CC.Center>
          <CustomFormControl
            isLoading={isLoading}
            isInvalid={!!errors[automaticReloadParametersFormMeta.automaticReload.name]} w={"auto"}
          >
            <CustomInput
              hasError={errors[automaticReloadParametersFormMeta.automaticReload.name]}
              register={register(automaticReloadParametersFormMeta.automaticReload.name)}
              meta={automaticReloadParametersFormMeta.automaticReload}
            />
          </CustomFormControl>

        </CC.Center>

      </CustomFieldSet>

      <CC.HStack my={4} justifyContent={'flex-end'}>
        <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack>
    </CC.Box>
  );
};

export default PrePaidReloadParametersFormUI;
